// extracted by mini-css-extract-plugin
module.exports = {"circle":"gallery_circle__bSe1H","group":"gallery_group__fEqSI"};